export default __webpack_public_path__ + "static/media/memo.245282c1.svg";